(function ($) {
	// Feature test to check if the browser supports native anchor positioning.
	const supportsNativeAnchorPositioning = 'anchorName' in document.documentElement.style;

	class W4D_Dropdown {
		constructor() {
			this.initSelectors();
			this.$activeTrigger = null;
			this._cleanupScroll = null; // Tracks window frame event cleanup

			if (this.$triggers.length) {
				this.bindEvents();
			}
		}

		initSelectors() {
			this.$triggers = $('.dropdown-trigger');
		}

		bindEvents() {
			// Used for dynamic dropdowns through <template> elements
			$(document).on('click', '.dropdown-trigger', (e) => this.handleDropdownToggle($(e.currentTarget)));
		}

		/**
		 * Pure JS Fallback Path: Manually links and positions the top-layer popover
		 * directly beneath the clicked trigger element without causing DOM bloat.
		 */
		applyAnchorFallback($button, $popover) {
			const triggerEl = $button[0];
			const popoverEl = $popover[0];

			// 1. Drop any scroll track loops attached to a previously open dropdown
			if (this._cleanupScroll) {
				this._cleanupScroll();
			}

			this.$activeTrigger = $button;

			// 2. Compute exact coordinate mapping relative to the viewport
			const updatePosition = () => {
				const triggerRect = triggerEl.getBoundingClientRect();

				popoverEl.style.position = 'fixed';
				popoverEl.style.top = `${triggerRect.bottom}px`;
				// Aligns the right edge of the popover exactly with the right edge of the trigger
				popoverEl.style.right = `${window.innerWidth - triggerRect.right}px`;
				popoverEl.style.left = 'auto';
				popoverEl.style.transform = 'none';
			};

			// 3. Defer coordinate execution by one frame so the Popover API has
			// initialized its top-layer transition and display styles.
			let frameId = requestAnimationFrame(updatePosition);

			const handleUpdate = () => {
				cancelAnimationFrame(frameId);
				frameId = requestAnimationFrame(updatePosition);
			};

			// capture: true intercepts scroll actions occurring inside nested layout containers
			window.addEventListener('scroll', handleUpdate, { capture: true, passive: true });
			window.addEventListener('resize', handleUpdate, { passive: true });

			this._cleanupScroll = () => {
				cancelAnimationFrame(frameId);
				window.removeEventListener('scroll', handleUpdate, { capture: true });
				window.removeEventListener('resize', handleUpdate);
				this._cleanupScroll = null;
			};

			// 4. Detach event listeners when the popover light-dismisses or closes
			if (!popoverEl._hasToggleListener) {
				popoverEl._hasToggleListener = true;
				popoverEl.addEventListener('toggle', (e) => {
					if (e.newState !== 'open' && this._cleanupScroll) {
						this._cleanupScroll();
					}
				});
			}
		}

		handleDropdownToggle($button) {
			const templateId = $button.data('template');
			const popoverId = $button.data('popover-id');

			if (!templateId || !popoverId) return;

			let $popover = $(`#${popoverId}`);

			if (!$popover.length) {
				const template = document.getElementById(templateId);
				if (template) {
					const clone = template.content.cloneNode(true);
					const $article = $(clone).find('article.dropdown');
					$article.attr('id', popoverId);
					$('body').append(clone);
					$popover = $(`#${popoverId}`);
				}
			}

			const buttonData = $button.data();
			Object.keys(buttonData).forEach((key) => {
				$popover.data(key, buttonData[key]);
				const kebabKey = key.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
				$popover.attr(`data-${kebabKey}`, buttonData[key]);
			});

			const orderId = $button.data('order-id');
			const $viewDetails = $popover.find('[data-js-view-details]');
			if ($viewDetails.length && orderId) {
				const baseUrl = $viewDetails.data('url');
				if (baseUrl) {
					$viewDetails.attr('href', `${baseUrl}?id=${orderId}`);
				}
			}

			// Fire the manual coordinate calculation right before opening the popover container
			if (!supportsNativeAnchorPositioning) {
				this.applyAnchorFallback($button, $popover);
			}

			const popoverDOM = $popover[0];
			if (popoverDOM) {
				try {
					// Implicitly anchor the popover to the clicked button (Native path)
					popoverDOM.showPopover({ source: $button[0] });
				} catch (error) {
					console.error('Popover API interaction error:', error);
				}
			}
		}
	}

	$(document).ready(function () {
		new W4D_Dropdown();
	});
})(jQuery);
